import { rootElement } from '@shared/setup';
import Themes from './Themes.vue';

const initThemes = async () => {
    rootElement({
        name: 'ThemesRoot', // pascal, camel & kebab-case are valid
        component: Themes,
        vm: {},
        contextComponents: ['<div>Waiting...</div>'],
    });
};

initThemes();
